import { useState } from "react";
import type { Clarification } from "../../../types/clarification.type";

interface UseSelectionStateOptions {
  selectableItems: Clarification[];
}

export const useSelectionState = ({ selectableItems }: UseSelectionStateOptions) => {
  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  const handleToggleSelection = (id: number) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    if (selectedIds.length === selectableItems.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(selectableItems.map((c) => c.id));
    }
  };

  const clearSelection = () => setSelectedIds([]);

  const selectedItemsForSending = selectableItems.filter((c) => selectedIds.includes(c.id));
  const supplierNameForSend = selectableItems[0]?.supplier_name || "supplier";

  return {
    selectedIds,
    setSelectedIds,
    handleToggleSelection,
    handleSelectAll,
    clearSelection,
    selectedItemsForSending,
    supplierNameForSend,
  };
};

export type SelectionStateReturn = ReturnType<typeof useSelectionState>;
